import React from 'react';
import { UserCheck, HelpCircle } from 'lucide-react';

const SelfEmployedSection = ({ formData, handleInputChange, errors }) => {
  // Если статус самозанятого не выбран, возвращаем только checkbox
  if (!formData.isSelfEmployed) {
    return (
      <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between">
          <label htmlFor="isSelfEmployed" className="flex items-center cursor-pointer text-sm font-medium text-gray-700 dark:text-gray-300">
            <UserCheck className="w-5 h-5 mr-2 text-indigo-500" />
            <span>Самозанятый (НПД)</span>
          </label>
          <div>
            <input
              type="checkbox"
              id="isSelfEmployed"
              name="isSelfEmployed"
              checked={formData.isSelfEmployed}
              onChange={handleInputChange}
              className="form-checkbox"
              disabled={formData.isIp}
            />
          </div>
        </div>
        {formData.isIp && (
          <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
            Нельзя одновременно быть ИП и самозанятым с одним видом деятельности.
          </p>
        )}
      </div>
    );
  }

  // Если выбран статус самозанятого, показываем дополнительные параметры
  return (
    <div className="mb-6 bg-emerald-50 dark:bg-emerald-900/20 p-4 rounded-lg border border-emerald-100 dark:border-emerald-800">
      <div className="flex items-center justify-between mb-4">
        <label htmlFor="isSelfEmployed" className="flex items-center cursor-pointer text-sm font-medium text-gray-700 dark:text-gray-300">
          <UserCheck className="w-5 h-5 mr-2 text-emerald-500" />
          <span>Самозанятый (НПД)</span>
        </label>
        <div>
          <input
            type="checkbox"
            id="isSelfEmployed"
            name="isSelfEmployed"
            checked={formData.isSelfEmployed}
            onChange={handleInputChange}
            className="form-checkbox"
          />
        </div>
      </div>

      {/* Информационный блок */}
      <div className="mt-2">
        <div className="flex items-start bg-emerald-100 dark:bg-emerald-900/30 p-3 rounded-lg border border-emerald-200 dark:border-emerald-800">
          <HelpCircle className="w-5 h-5 text-emerald-600 dark:text-emerald-400 mr-3 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-emerald-700 dark:text-emerald-300 mb-1">
              Налог на профессиональный доход (НПД)
            </h4>
            <p className="text-xs text-emerald-600 dark:text-emerald-400">
              Специальный налоговый режим для самозанятых граждан предусматривает следующие ставки:
            </p>
            <ul className="text-xs text-emerald-600 dark:text-emerald-400 list-disc pl-4 mt-1 space-y-1">
              <li>4% от доходов, полученных от физических лиц</li>
              <li>6% от доходов, полученных от ИП и юридических лиц</li>
            </ul>
            <p className="text-xs text-emerald-600 dark:text-emerald-400 mt-2">
              НПД заменяет НДФЛ в отношении доходов от профессиональной деятельности. Самозанятым не нужно подавать налоговую декларацию и платить страховые взносы. Лимит дохода для самозанятых — 2,4 млн ₽ в год.
            </p>
            <p className="text-xs text-emerald-600 dark:text-emerald-400 mt-2">
              В текущем расчете применяется ставка 4% (доходы от физических лиц).
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelfEmployedSection;